import { useEffect, useMemo, useState } from "react";
import { fmtCFA } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { payLabel } from "@/hooks/useCaisse";

const inputCls = "bg-background border-border text-foreground";

export default function PayDialog({ paiement, total, busy, onClose, onConfirm }) {
  const [recu, setRecu] = useState("");
  const [reference, setReference] = useState("");
  useEffect(() => { setRecu(""); setReference(""); }, [paiement]);
  const rendu = useMemo(() => Math.max(0, Number(recu || 0) - total), [recu, total]);
  const mobile = paiement && paiement !== "especes";

  return (
    <Dialog open={!!paiement} onOpenChange={onClose}>
      <DialogContent className="bg-card border-border text-foreground">
        <DialogHeader>
          <DialogTitle data-testid="pay-dialog-title">Paiement {paiement === "especes" ? "en espèces" : `par ${payLabel(paiement)}`}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="flex justify-between text-lg font-bold text-emerald-600 dark:text-emerald-400">
            <span>Total à encaisser</span>
            <span data-testid="pay-total">{fmtCFA(total)}</span>
          </div>
          {paiement === "especes" && (
            <>
              <div className="space-y-2">
                <Label className="text-foreground/80">Montant reçu</Label>
                <Input type="number" min="0" value={recu} onChange={(e) => setRecu(e.target.value)} data-testid="montant-recu-input" className={inputCls} />
              </div>
              <div className="flex justify-between text-sm text-foreground/80">
                <span>Rendu monnaie</span>
                <span className="font-bold text-amber-600 dark:text-amber-400" data-testid="rendu-monnaie">{fmtCFA(rendu)}</span>
              </div>
            </>
          )}
          {mobile && (
            <div className="space-y-2">
              <Label className="text-foreground/80">Numéro de transaction {payLabel(paiement)}</Label>
              <Input value={reference} onChange={(e) => setReference(e.target.value)} placeholder="Ex : TX7F3K9A2" data-testid="reference-transaction-input" className={inputCls} />
              <p className="text-xs text-muted-foreground">Obligatoire — référence reçue par SMS / application</p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="border-border text-foreground/80">Annuler</Button>
          <Button onClick={() => onConfirm(paiement, reference)} disabled={busy || (mobile && !reference.trim())} data-testid="confirm-pay-button" className="bg-emerald-500 hover:bg-emerald-600 text-white">
            Valider la vente
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
